<template>
  <div class="wizard-step-1">
    <document-type-search
      v-model="searchQuery"
      :total-types="documentTypes.length"
      :filtered-count="filteredTypes.length"
    />
    
    <div v-if="filteredTypes.length > 0" class="document-types-grid">
      <document-type-card
        v-for="type in filteredTypes"
        :key="type.value"
        :type="type"
        :selected="selectedType === type.value"
        @click="$emit('select', type.value)"
      />
    </div>
    
    <div v-else class="no-results">
      <feather-icon icon="SearchIcon" size="48" class="mb-3" />
      <p class="mb-0">No se encontraron tipos de documentos que coincidan con "{{ searchQuery }}"</p>
    </div>
  </div>
</template>

<script>
import DocumentTypeCard from './DocumentTypeCard.vue';
import DocumentTypeSearch from './DocumentTypeSearch.vue';

export default {
  name: 'WizardStep1SelectType',
  components: {
    DocumentTypeCard,
    DocumentTypeSearch
  },
  props: {
    documentTypes: {
      type: Array,
      required: true
    },
    selectedType: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      searchQuery: ''
    };
  },
  computed: {
    filteredTypes() {
      if (!this.searchQuery) return this.documentTypes;
      
      const query = this.searchQuery.toLowerCase();
      return this.documentTypes.filter(type =>
        type.value.toLowerCase().includes(query) ||
        type.text.toLowerCase().includes(query)
      );
    }
  },
  mounted() {
    console.log('🔵 Step1: mounted', {
      documentTypes: this.documentTypes.length,
      selectedType: this.selectedType
    });
  },
  watch: {
    documentTypes(newVal) {
      console.log('🔵 Step1: documentTypes changed', newVal.length, 'types');
    }
  }
};
</script>

<style lang="scss" scoped>
.wizard-step-1 {
  .document-types-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    gap: 1.5rem;
    
    @media (max-width: 992px) {
      grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
      gap: 1rem;
    }
    
    @media (max-width: 768px) {
      grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
      gap: 1rem;
    }
    
    @media (max-width: 576px) {
      grid-template-columns: repeat(2, 1fr);
      gap: 0.75rem;
    }
  }
  
  .no-results {
    text-align: center;
    padding: 3rem 1rem;
    color: #6c757d;
    
    svg {
      opacity: 0.5;
    }
    
    p {
      font-size: 1rem;
    }
  }
}
</style>
